import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'
import { fetchChain, updateChain } from 'utils/api/chainApi'
import { updateChainSchema } from 'utils/schema/chainSchema'
import { PAGE_CHAIN_MGMT, PAGE_NOT_FOUND } from 'utils/constants'
import { Button, Spinner } from 'components/common'
import { ChainDetailsForm } from 'components/chainManagement'
import BackButton from 'components/backButton'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { handleError } from 'utils/helpers/handleError'
import { FileSourceType } from 'components/chainManagement/utils'

const UpdateChainPage = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState<boolean>(true)
  const [chain, setChain] = useState<any>({})

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(updateChainSchema) })

  const getChainDetails = async (chainId: string) => {
    try {
      const { data } = await fetchChain(chainId)
      data.chainId = data._id
      setChain(data)
      delete data._id
      reset(data)
    } catch {
      setChain({})
      navigate(PAGE_NOT_FOUND.path)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) getChainDetails(id)
  }, [])

  if (loading) return <Spinner />

  const handleUpdateChain = async (data: any) => {
    if (!id) return

    const toastId = toast.loading('Updating chain...', { duration: Infinity })
    try {
      delete data.chainId

      const isChainFtp = data.fileSourceType === FileSourceType.CHAIN_FTP
      const isInternalFtp = data.fileSourceType === FileSourceType.INTERNAL_FTP
      const payload = {
        ...data,
        ftp: isChainFtp
          ? data.ftp
          : isInternalFtp
            ? { baseDirectory: data.ftp?.baseDirectory }
            : undefined,
      }

      await updateChain(id, payload)
      toast.success('Chain updated successfully!', {
        id: toastId,
        duration: 3000,
      })
      reset()
      navigate(PAGE_CHAIN_MGMT.path)
    } catch (error) {
      handleError(error, toastId, { default: 'Failed to update chain!' })
    }
  }

  return (
    <>
      <BackButton />

      <form onSubmit={handleSubmit(handleUpdateChain)}>
        <ChainDetailsForm
          register={register}
          errors={errors}
          setValue={setValue}
          watch={watch}
          chain={chain}
          isOptional
        />

        <Button buttonText="Update Chain" className="mt-7 w-44" />
      </form>
    </>
  )
}

export default UpdateChainPage
